import { render } from "./SubmitEditorCmp.vue?vue&type=template&id=7be357f2"
import script from "./SubmitEditorCmp.vue?vue&type=script&lang=js"
export * from "./SubmitEditorCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__